import {AxiosError} from 'axios'

/** drf-standardized-errors envelope; not part of the OpenAPI schema, see API-CONTRACT.md §2 */
export interface StandardizedError {
    code: string
    detail: string
    attr: string | null
}

export interface StandardizedErrorResponse {
    type: 'validation_error' | 'client_error' | 'server_error'
    errors: StandardizedError[]
}

export const getApiErrorMessage = (error: AxiosError): string => {
    const data = error.response?.data as (Partial<StandardizedErrorResponse> & { detail?: string }) | undefined
    if (!data) return error.message
    if (Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors.map(e => e.detail).join('\n')
    }
    return data.detail ?? error.message
}

/** 409 = wrong-state workflow transition ("Request already processed") */
export const isConflictError = (error: unknown): boolean =>
    error instanceof AxiosError && error.response?.status === 409
